export const FreeTrialStatus = {
  FREE_TRIAL: "FREE TRIAL",
  NO_FREE_TRIAL: "NO FREE TRIAL"
};

export const getAllFreeTrialStatus = () => Object.values(FreeTrialStatus);
